import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var selectDefaultFromAddress = mutatorAction('selectDefaultFromAddress', function (defaultFromAddress) {
    var store = connectedAccountsStore();
    store.defaultFromState.defaultFromAddress = defaultFromAddress;
});
//# sourceMappingURL=selectDefaultFromAddress.js.map